import { useEffect, useRef } from 'react';
import { Camera, WebGLRenderer } from 'three';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';

import { isDefined } from '../../../utils/variables';

export type RenderItem = {
  render: (camera: Camera) => void;
  renderer: WebGLRenderer | CSS2DRenderer;
};

/**
 * Setup ThreeJS animation loop for the given render items.
 * When the component goes out of scope the animation cycle
 * will automatically be cancelled.
 */
export function useAnimate(items: RenderItem[], camera?: Camera) {
  const ref = useRef<number>();

  useEffect(() => {
    if (items.length === 0 || !isDefined(camera)) {
      return;
    }

    const animate = () => {
      for (const item of items) {
        item.render(camera);
      }

      ref.current = requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    return () => {
      if (isDefined(ref.current)) {
        cancelAnimationFrame(ref.current);
      }
    };
  }, [items, camera]);
}
